<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-autocomplete
            ref="autocomplete"
            v-bind="$attrs"
            v-on="$listeners"
            v-model="m_value"
            :items="m_items"
            :item-value="itemValue"
            :item-text="itemText"
            :filter="filter"
            :search-input.sync="search"
            :menu-props="{maxHeight: 400}"
            :hide-no-data="(search||'').length < minLength"
            :loading="m_loading"
            :no-data-text="m_loading ? 'Buscando...' : $vuetify.noDataText"
            :hint="getHint()"
            :multiple="multiple"
            :hide-selected="_.get($attrs,'hide-selected',true)"
            :cache-items="_.get($attrs,'cache-items',true)"
            :readonly="m_value && m_value.length >= maxItems"
            validate-on-blur
            clearable
            solo flat>
        <slot name="append" slot="append">
            <select-arrow></select-arrow>
        </slot>
        <template v-if="multiple" v-slot:selection="{ selected, item }">
            <v-chip
                    :selected="selected"
                    close
                    class="chip--select-multi"
                    @input="remove(item)">
                {{ item[itemText] }}
            </v-chip>
        </template>
    </v-autocomplete>
</template>

<script>
import { debounce } from 'lodash'
import SelectArrow from '../components/SelectArrow'

export default {
  name: 'Autocomplete',
  components: { SelectArrow },
  props: {
    'url': String,
    'params': Object,
    'min-length': { type: [Number, String], default: 2 },
    'max-items': { type: [Number, String], default: Infinity },
    'value': [Array, Object, String, Number],
    'items': Array,
    'loading': Boolean,
    'multiple': Boolean,
    'hierarquia': { default: false },
    'item-value': {
      type: String,
      required: true
    },
    'item-text': {
      type: String,
      required: true
    }
  },
  data: () => ({
    m_loading: false,
    m_items: [],
    m_value: [],
    search: ''
  }),
  watch: {
    items (val) {
      this.m_items = val
    },
    value (val) {
      this.m_value = val
    },
    m_value (val) {
      if (this.m_value && this.m_value.length >= this.maxItems) {
        this.$refs.autocomplete.blur()
      }
      this.$emit('input', val)
    },
    loading (val) {
      this.m_loading = val
    },
    search (term) {
      this.trigger(term)
    },
    params () {
      this.trigger()
    }
  },
  methods: {
    getHint () {
      if (this.m_value && this.m_value.length >= this.maxItems) {
        return 'Só são permitidos ' + this.maxItems + ' itens'
      }
      return this.url ? 'Digite para buscar' : ''
    },
    retiraAcentos (texto) {
      if (!texto) {
        return
      }
      texto = texto.replace(/[ÀÁÂÃÄÅ]/i, 'A')
      texto = texto.replace(/[ÈÉÊË]/i, 'E')
      texto = texto.replace(/[Ç]/i, 'C')
      return texto
    },
    filter (item, queryText, itemText) {
      queryText = this.retiraAcentos(queryText)
      queryText = queryText.toUpperCase()

      itemText = this.retiraAcentos(itemText)
      itemText = itemText.toUpperCase()

      return itemText.indexOf(queryText) > -1
    },
    trigger (term) {
      if (term === undefined) {
        term = this.search
      }
      if (this.url) {
        if ('cancel' in this.$http) {
          this.$http.cancel(this._uid)
        }
        this.autocomplete(term)
      }
    },
    autocomplete: debounce(function (term) {
      term = term || ''
      if (term.length >= this.minLength) {
        this.m_loading = true
        if (this.hierarquia) {
          this.$http.post(this.url, {
            requestId: this._uid,
            params: { term, ...this.params },
            options: { silent: true }
          }).then(res => {
            this.m_items = res.data
            this.$emit('update:items', res.data)
          }).catch(() => {
            // cancel
          }).finally(() => {
            this.m_loading = false
          })
        } else {
          this.$http.get(this.url, {
            requestId: this._uid,
            params: { term, ...this.params },
            options: { silent: true }
          }).then(res => {
            this.m_items = res.data
            this.$emit('update:items', res.data)
          }).catch(() => {
            // cancel
          }).finally(() => {
            this.m_loading = false
          })
        }
      }
    }, 500),
    remove (item) {
      const index = this.m_value.indexOf(item[this.itemValue])
      if (index >= 0) { this.m_value.splice(index, 1) }
    }
  },
  mounted () {
    this.m_items = this.items
    this.m_value = this.value
  }
}

</script>

<style scoped>

</style>
